<template>
  <v-card elevation="2" class="pa-4">
    <div class="d-flex">
      <v-spacer></v-spacer>
      <div class="mx-n2">
        <VisibilityToggleButton
          v-model="showRankTable"
          :show-text="$t('ranks.showRankTable')"
          :hide-text="$t('ranks.hideRankTable')"
        />
        <InstructionIcon v-model="showInstruction" />
        <InstructionList
          :show="showInstruction"
          :list="$t('ranks.instructions')"
        />
      </div>
    </div>
    <div v-show="showRankTable">
      <v-row>
        <v-col cols="12" lg="6">
          <RankTable :headers="moodsHeaders" :rows="moodsRows" />
        </v-col>
        <v-col cols="12" lg="6">
          <RankTable :headers="motifsHeaders" :rows="motifsRows" />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import VisibilityToggleButton from "@/components/VisibilityToggleButton.vue";
import InstructionList from "@/components/InstructionList.vue";
import InstructionIcon from "@/components/InstructionIcon.vue";
import RankTable from "./RankTable.vue";
import { getAllItems, countItems } from "@/utils/process-rank-data";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    VisibilityToggleButton,
    InstructionIcon,
    InstructionList,
    RankTable
  },
  data: () => ({
    showRankTable: true,
    showInstruction: false,
    moodRankMap: new Map(),
    motifRankMap: new Map()
  }),
  computed: {
    ...mapState(["poems"]),
    ...mapGetters(["sankeyThemesSet", "colorScale"]),
    allMoods() {
      return getAllItems(this.poems, "mood");
    },
    allMotifs() {
      return getAllItems(this.poems, "motif");
    },
    moodsHeaders() {
      return this.getHeaders("mood", this.sankeyThemesSet);
    },
    motifsHeaders() {
      return this.getHeaders("motif", this.sankeyThemesSet);
    },
    moodsRows() {
      return this.getRows(
        "mood",
        this.allMoods,
        this.poems,
        this.sankeyThemesSet
      );
    },
    motifsRows() {
      return this.getRows(
        "motif",
        this.allMotifs,
        this.poems,
        this.sankeyThemesSet
      );
    }
  },
  methods: {
    getHeaders(type, themes) {
      return [
        {
          text: this.$t(`data.${type}`),
          value: "key",
          sortable: true,
          filterable: true
        },
        ...["_all", ...themes].map(theme => ({
          text: theme === "_all" ? this.$t("ranks.allPoems") : theme,
          value: theme,
          sortable: true,
          filterable: false,
          align: "end"
        }))
      ];
    },
    getRows(type, allWords, poems, themes) {
      if (poems.length === 0) return [];
      return allWords.map(word => {
        const d = { key: word };
        ["_all", ...themes].forEach(theme => {
          if (!this[`${type}RankMap`].has(theme)) {
            this[`${type}RankMap`].set(
              theme,
              countItems(poems, type, theme === "_all" ? null : theme, "theme")
            );
          }
          d[theme] = this[`${type}RankMap`].get(theme).get(word) || 0;
        });
        return d;
      });
    }
  }
};
</script>
